module.exports = __webpack_public_path__ + "static/media/megaphone.8eef6348.svg";